<template>
  <!-- 报文指令 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 设备编码 -->
        <el-form-item :label="$t('pages.research.text73')">
          <el-input
            v-model="searchParams.devCode"
            placeholder=""
            clearable
          ></el-input>
        </el-form-item>
        <!-- 指令类别 -->
        <el-form-item :label="$t('pages.equipment.text176')">
          <el-select v-model="searchParams.cmdType" clearable placeholder="">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 指令时间 -->
        <el-form-item :label="$t('pages.research.text74')">
          <el-date-picker
            v-model="startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮区域 -->
    <div class="searchSubmit">
      <DiluButton type="search" @click="search"></DiluButton>
      <DiluButton type="reset" @click="reset"></DiluButton>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column
        prop="devCode"
        :label="$t('pages.research.text73')"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        :label="$t('pages.research.text74')"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="cmdType"
        :label="$t('pages.research.text75')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="serialNum"
        :label="$t('pages.research.text76')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        :label="$t('pages.research.text77')"
        align="left"
      >
        <template slot-scope="scope">
          <span class="instructions" v-if="scope.row.result != null">
            {{ scope.row.result }}
          </span>
          <span v-if="scope.row.original != null">
            {{ scope.row.original }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="showCmd(scope.row)" type="text" size="small">{{
              $t("pages.research.text78")
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 详情弹窗 -->
    <el-dialog
      :title="$t('pages.research.text78')"
      :visible.sync="detailVisible"
      width="600px"
      padding-top="10px"
    >
      <JsonView :json="jsonData"></JsonView>
    </el-dialog>
  </div>
</template>


<script>
import JsonView from "./module/jsonView";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        devCode: "", //设备编码
        lastTime: "", //指令时间
        cmdType: "noheartbt", //指令类别
        pageNum: 1, //页码
        pageSize: 10, //每页最大条数
      },
      startAt: "", //选择的开始日期
      stopAt: "", //选择的结束日期
      options: [
        {
          value: "鉴权",
          label: "鉴权",
        },
        {
          value: "状态",
          label: "状态",
        },
        {
          value: "信息",
          label: "信息",
        },
        {
          value: "心跳",
          label: "心跳",
        },
        {
          value: "应答",
          label: "应答",
        },
        {
          value: "离线",
          label: "离线",
        },
        {
          value: "服务中止",
          label: "服务中止",
        },
        {
          value: "重启",
          label: "重启",
        },
        {
          value: "睡眠",
          label: "睡眠",
        },
        {
          value: "锁控",
          label: "锁控",
        },
        {
          value: "灯控",
          label: "灯控",
        },
        {
          value: "寻车",
          label: "寻车",
        },
        {
          value: "查询状态",
          label: "查询状态",
        },
        {
          value: "查询版本",
          label: "查询版本",
        },
        {
          value: "设置速度",
          label: "设置速度",
        },
        {
          value: "升级CCU",
          label: "升级CCU",
        },
        {
          value: "操作模式",
          label: "操作模式",
        },
        {
          value: "语音控制",
          label: "语音控制",
        },
        {
          value: "切换服务器",
          label: "切换服务器",
        },
        {
          value: "升级ECU",
          label: "升级ECU",
        },
        {
          value: "音频升级",
          label: "音频升级",
        },
        {
          value: "查询参数",
          label: "查询参数",
        },
        {
          value: "设置参数",
          label: "设置参数",
        },
        {
          value: "重置氢瓶",
          label: "重置氢瓶",
        },
        {
          value: "noheartbt",
          label: "不包含心跳",
        },
        {
          value: "noheartbtandstatus",
          label: "不包含状态和心跳",
        },
      ],
      tableConfig: {
        isTree: false,
        isPage: true, //开启分页
      },
      total: 0,
      detailVisible: false, //详情弹窗
      jsonData: {},
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    JsonView,
  },
  mounted() {
    this.getCmdList();
  },
  methods: {
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.getCmdList();
    },
    //更改开始日期时结束日期置空重选
    startChange() {
      this.stopAt = "";
    },
    //获取报文指令列表
    getCmdList() {
      if (this.stopAt && this.startAt) {
        this.stopAt = resetDate(this.stopAt); // 结束时间
        this.startAt = resetDate(this.startAt); // 开始时间
        this.searchParams.lastTime = [this.startAt, this.stopAt];
      } else {
        this.searchParams.lastTime = "";
      }
      if (this.startAt) {
        if (!this.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.stopAt) {
        if (!this.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.cmdList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //重置
    reset() {
      this.searchParams = {
        devCode: "", //设备编码
        lastTime: "", //指令时间
        cmdType: "", //指令类别
        pageNum: 1,
        pageSize: 10,
      };
      (this.startAt = ""), //选择的开始日期
        (this.stopAt = ""), //选择的结束日期
        (this.total = 0);
      this.getCmdList();
    },
    //显示指令详情
    showCmd(e) {
      this.jsonData = JSON.parse(e.json);
      this.detailVisible = true;
    },
    //翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.getCmdList();
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
}
.searchSubmit {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
.instructions {
  display: block;
}
</style>